<template>
  <b-modal
    no-close-on-backdrop
    id="change_geolocation"
    title="ALTERAR GEOLOCALIZAÇÃO"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <Geolocation
      :user_id="user_id"
      :geolocation="geolocation"
      @save="$emit('save')"
    />
  </b-modal>
</template>

<script>
import Geolocation from "../Account/Geolocation";

import permission from "../../lib/permission";

export default {
  name: "ChangeGeolocation",

  components: {
    Geolocation,
  },

  data() {
    return {};
  },

  props: {
    user_id: {
      type: [Number, String],
    },

    geolocation: {
      type: [Number, String],
    },
  },

  methods: {
    permission,

    async evOnShow() {},

    async evOnShown() {},

    async evOnHide() {},
  },
};
</script>

<style></style>
